import React from "react";

import Pages from "./Pages/Pages";

function App() {
  return (
    <div>
      <Pages />
    </div>
  );
}

export default App;
